import { createFileRoute } from "@tanstack/react-router";
import type React from "react";

import { Exports } from "@/features/settings/export-history";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/exporte",
)({
  component: ExportsScreen,
});

function ExportsScreen() {
  return <Exports />;
}
